import './App.css';
import routes from './Router';
import NavBar from './Pages/NavBar/NavBarLeft';
import NavBarTop from './Pages/NavBar/NavBarTop';
import { greenTheme } from './Themes/GreenTheme';



// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { useEffect, useState } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import LoaderComponent from './Components/LoaderComponent/LoaderComponent';
import ThemeServices from './Services/ThemeServices';




// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyButDdXHVb-LDOjnJI1I5wat8EhamgpUIk",
  authDomain: "taxai-db12c.firebaseapp.com",
  projectId: "taxai-db12c",
  storageBucket: "taxai-db12c.appspot.com",
  messagingSenderId: "115397646890",
  appId: "1:115397646890:web:3da08c39c5c3443cea4153"
};

/**
 * Interface for theme config Response (POST)
 */
interface TenantConfigResponse {
  tenant_id: string | null;
  tenant_name: string | null;
  is_active: boolean;
  domain: string | null;
  theme: any;
  assets: any;
  tenant_index: number;
}

try {
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);

  const messaging = getMessaging(app);

  Notification.requestPermission().then((permission) => {
    console.log(permission);
    if (permission === 'granted') {
      // console.log('Notification permission granted.');
      // Add the public key generated from the console here.
      getToken(messaging,
        { vapidKey: "BK3v3_cJLnliFw-o1EVgLrXnAxYu3O2ILY6WbDZ5JjHnG3jBLiZwkyj1BmcQyo-vD7CeULT-BlClViTdy6p5f5w" }
      ).then((currentToken) => {
        if (currentToken) {
          console.log(currentToken);
          // Send the token to your server and update the UI if necessary
          // ...
        } else {
          // Show permission request UI
          console.log('No registration token available. Request permission to generate one.');
          // ...
        }
      }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
        // ...
      });

      console.log(messaging);
    }
  });

  onMessage(messaging, (payload) => {
    console.log('Message received. ', payload);
    // ...
  });
}
catch (err) {
  console.log(err);
}

function App() {
  let isMenuVisible: boolean = leftNavVisibleType();
  const [theme, setTheme] = useState(
    createTheme({
      palette: {
        primary: {
          main: '#4caf50',
          contrastText: '#ffffff',
        },
        secondary: {
          main: '#ff9800',
          contrastText: '#ffffff',
        },
      },
    })
  );
  useEffect(() => {
    const domain = window.location.hostname;
    const postData = {
      doaminName: (domain == 'localhost') ? "taxrefunds.easaly.ai" : domain
    }
    const savedTenant = localStorage.getItem('TENANT_CONFIG');
    // Use cached data if available
    if (savedTenant) {
      const tenantData = JSON.parse(savedTenant);
      applyTheme(tenantData);
      // Set page title
      document.title = tenantData?.tenant_name || '';
      return;
    }
    ThemeServices.getTenantConfig(postData).then(response => {
      if (response.ok) {
        response.json().then((res) => {
          res.tenant_name = res.tenant_name == 'Covid Tax Refunds' ? 'EasAly Tax Resolution' : res.tenant_name;
          // Set page title
          document.title = res?.tenant_name || '';
          // Save entire response
          localStorage.setItem(
            'TENANT_CONFIG',
            JSON.stringify(res)
          );
          applyTheme(res);
          // Reload the current page (not '/') so components reading TENANT_CONFIG on mount pick it up,
          // without sending public pages (e.g. /installmentagreement) to the login screen.
          window.location.reload();
        });
      } else {
        console.log('error response');
      }
    })
  }, []);

  const applyTheme = (res: any) => {

    const root = document.querySelector('.custom-theme') as HTMLElement;
    const themeConfig = JSON.parse(res.theme);
    const dynamicTheme = createTheme({
      palette: {
        primary: {
          main: themeConfig.primary,
          contrastText: themeConfig.contrastText,
        },
        secondary: {
          main: themeConfig.secondary,
          contrastText: themeConfig.contrastText,
        },
      },
    });

    setTheme(dynamicTheme);

    // Update CSS variables globally
    document.documentElement.style.setProperty(
      '--primary-main',
      themeConfig.primary
    );

    document.documentElement.style.setProperty(
      '--secondary-main',
      themeConfig.secondary
    );

    document.documentElement.style.setProperty(
      '--contrast-text',
      themeConfig.contrastText
    );

    // Favicon
    const favicon = document.querySelector(
      "link[rel='icon']"
    ) as HTMLLinkElement;
    const favIconUrl = res?.assets?.find(
      (x: string) => x.indexOf('fav_icon.png') !== -1
    );
    if (favicon && favIconUrl) {
      favicon.href = favIconUrl;
    }
  };
  return (
    <div className="App">
      <ThemeProvider theme={theme}>

        {
          isMenuVisible ? <NavBar /> : null
        }

        <div className="body-container">
          {
            // Header will not display in registration screen
            isMenuVisible ? <NavBarTop /> : null
          }
          {routes}
        </div>
      </ThemeProvider>
      <LoaderComponent />

    </div>

  );

  function leftNavVisibleType() {
    let url_ = window.location.href.replace(window.location.origin, '').replace('#', '').toLocaleLowerCase();
    let visibleType = false;

    if (url_.indexOf('/form8821') !== -1 || url_.indexOf('/useractions') !== -1 || url_.indexOf('/dashboard') !== -1
      || url_.indexOf('/chatgpt/pdfupload') !== -1 || url_.indexOf('/expensevalidation') !== -1 || url_.indexOf('/getalleligibleplans') !== -1
      || url_.indexOf('/invalidate') !== -1 || url_.indexOf('/subscriptionlist') !== -1 || url_.indexOf('rejectedusers') !== -1
      || url_.indexOf('/userprogress') !== -1 || url_.indexOf('/reviewpayment') !== -1 || url_.indexOf('/interestdetails') !== -1
      || url_.indexOf('reviewproofs') !== -1 || url_.indexOf('/kwongclaims') !== -1 || url_.indexOf('/kwongclaimsdetails') !== -1
      || url_.indexOf('/form433areview') !== -1 || url_.indexOf('/casedashboard') !== -1) {
      visibleType = true;
    }

    return visibleType;
  }
}



export default App;
